import { render, staticRenderFns } from "./WalterIAIcon.vue?vue&type=template&id=099b56a0&scoped=true"
import script from "./WalterIAIcon.vue?vue&type=script&lang=js"
export * from "./WalterIAIcon.vue?vue&type=script&lang=js"
import style0 from "./WalterIAIcon.vue?vue&type=style&index=0&id=099b56a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099b56a0",
  null
  
)

export default component.exports